import { render, staticRenderFns } from "./Detail-Inventory.vue?vue&type=template&id=5981c533"
import script from "./Detail-Inventory.vue?vue&type=script&lang=js"
export * from "./Detail-Inventory.vue?vue&type=script&lang=js"
import style0 from "./Detail-Inventory.vue?vue&type=style&index=0&id=5981c533&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports